export class OrigineDemande {
    id: number;
    name: string;
}


